import React, { useState, useEffect, createRef } from "react";
import { useForm } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import managementService from "../services/management-service";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Multiselect } from "multiselect-react-dropdown";
import moment from "moment";
const ManagementReportDownld = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, errors, setValue, getValues } = useForm({});
  const [facilityList, setFacilitiesList] = useState([]);
  const [groupCodeList, setGroupList] = useState([]);
  const [chargeCodeList, setChargeList] = useState([]);
  const [facSelected, setFacSelected] = useState([]);
  const [selectedCharges, setSelectedCharges] = useState();
  const [selectedGroups, setSelectedGroups] = useState();
  const [totalMonths, setTotalMonths] = useState([]);
  const [psychTab, setPsychTab] = useState();
  const parentFacRef = createRef();
  const chargeRef = createRef();
  const groupRef = createRef();
  //getFacilities
  useEffect(() => {
    getParentFacility();
    setTotalMonths(moment.months());
  }, []);
  const getParentFacility = async () => {
    try {
      setLoading(true);
      let totalFacList = await managementService.getParentFacilities();
      setLoading(false);
      setFacilitiesList(totalFacList);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving facility details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const [destroyedAmount, setDestroyedAmount] = useState(0);
  const onSubmit = async (data) => {
    setLoading(true);
    if (facSelected.length > 0) {
      const test = (val) => val === "true";
      try {
        const psych_tab_value = test(data.psych_tab);
        const generate_excel_value = test(data.generate_excel);
        let params = {
          parents: facSelected,
          groupCodes: selectedGroups,
          chargeCodes: selectedCharges,
          month: data.report_month,
          year: data.report_year,
          name: data.facility_display_name,
          medSurge: data.med_surge,
          inmate: data.inmate_count,
          psychTab: psych_tab_value,
          pdfAlso: generate_excel_value,
          destroyedAmount: destroyedAmount || 0,
        };
        const response = await managementService.eomExcel(params);
        if (response) {
          const { hide } = cogoToast.success(
            'Please wait while the management report is created.  It will appear in your "Management Reports"  when it is finished.',
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
        // let resp = await managementService.getReports();
        // await setManagementresultList({ updateList: resp.length });
        await history.push("/managementReport");
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving reports. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } else {
      const { hide } = cogoToast.error("Please Select Parent Facility.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
    setLoading(false);
  };
  async function facSelect() {
    let currentParentFac = parentFacRef.current.getSelectedItems();
    if (currentParentFac.indexOf("KNOX") > -1) {
      setValue("psych_tab", true);
      setPsychTab(true);
    } else {
      setValue("psych_tab", false);
      setPsychTab(false);
    }
    setFacSelected(currentParentFac.join(","));
    if (currentParentFac.length > 0) {
      setValue("facility_display_name", currentParentFac[0]);
    } else {
      setValue("facility_display_name", "");
    }
    groupRef.current.resetSelectedValues();
    chargeRef.current.resetSelectedValues();
    setSelectedGroups("");
    setSelectedCharges("");
    if (currentParentFac.length) {
      let report_month = getValues("report_month");
      let report_year = getValues("report_year");
      if (report_year !== "" && report_month !== "") {
        let params =
          "year=" +
          report_year +
          "&month=" +
          report_month +
          "&parent=" +
          currentParentFac;
        if (selectedGroups) {
          params = params + "&groupCodes=" + selectedGroups;
        }
        if (selectedCharges) {
          params = params + "&chargeCodes=" + selectedCharges;
        }
        try {
          setLoading(true);
          let getInmateMed = await managementService.getInmateMed(params);
          setValue("inmate_count", getInmateMed?.inmate);
          setValue("med_surge", getInmateMed?.medSurge);
          setLoading(false);
        } catch (e) {
          const { hide } = cogoToast.error(
            "Error retrieving details. Please contact administrator.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
          setLoading(false);
        }
      }
      try {
        setLoading(true);
        let totalGroupList = await managementService.getGroupCodes(
          currentParentFac.join(",")
        );
        setLoading(false);
        setGroupList(totalGroupList);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving details. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    } else {
      setValue("inmate_count", 0);
      setValue("med_surge", 0);
    }
  }
  async function grpSelect() {
    let currentGrpValue = groupRef.current.getSelectedItems();
    let report_month = getValues("report_month");
    let report_year = getValues("report_year");
    let params1 =
      "year=" +
      report_year +
      "&month=" +
      report_month +
      "&parent=" +
      facSelected;
    chargeRef.current.resetSelectedValues();
    if (currentGrpValue.length > 0) {
      setSelectedGroups(currentGrpValue.join(","));
      params1 = params1 + "&groupCodes=" + currentGrpValue.join(",");
      try {
        setLoading(true);
        let params = {
          parents: facSelected,
          groupsCodes: currentGrpValue.join(","),
        };
        let totalGroupList = await managementService.getChargeCodes(params);
        setChargeList(totalGroupList);
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving charge codes. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    } else {
      setSelectedGroups("");
      setSelectedCharges("");
    }
    if (facSelected && report_year !== "" && report_month !== "") {
      if (selectedCharges && currentGrpValue.length > 0) {
        params1 = params1 + "&chargeCodes=" + selectedCharges;
      }
      try {
        setLoading(true);
        let getInmateMed = await managementService.getInmateMed(params1);
        setValue("inmate_count", getInmateMed?.inmate);
        setValue("med_surge", getInmateMed?.medSurge);
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving details. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    }
  }
  async function chargeSelect() {
    let currentValue = chargeRef.current.getSelectedItems();
    let report_month = getValues("report_month");
    let report_year = getValues("report_year");
    let params1 =
      "year=" +
      report_year +
      "&month=" +
      report_month +
      "&parent=" +
      facSelected +
      "&groupCodes=" +
      selectedGroups;
    if (currentValue.length > 0) {
      setSelectedCharges(currentValue.join(","));
      params1 = params1 + "&chargeCodes=" + currentValue.join(",");
    }
    if (facSelected && report_year !== "" && report_month !== "") {
      try {
        setLoading(true);
        let getInmateMed = await managementService.getInmateMed(params1);
        setValue("inmate_count", getInmateMed?.inmate);
        setValue("med_surge", getInmateMed?.medSurge);
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving details. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  }
  async function changeYearMnth() {
    let report_month = getValues("report_month");
    let report_year = getValues("report_year");
    if (facSelected.length && report_year !== "" && report_month !== "") {
      let params =
        "year=" +
        report_year +
        "&month=" +
        report_month +
        "&parent=" +
        facSelected;
      if (selectedGroups) {
        params = params + "&groupCodes=" + selectedGroups;
      }
      if (selectedCharges) {
        params = params + "&chargeCodes=" + selectedCharges;
      }
      setLoading(true);
      let getInmateMed = await managementService.getInmateMed(params);
      setValue("inmate_count", getInmateMed?.inmate);
      setValue("med_surge", getInmateMed?.medSurge);
      setLoading(false);
    }
  }
  const totalYears = () => {
    const years = [];
    const dateStart = moment().subtract(2, "y");
    const dateEnd = moment().add(6, "y");
    while (dateEnd.diff(dateStart, "years") >= 0) {
      years.push(dateStart.format("YYYY"));
      dateStart.add(1, "year");
    }
    return years;
  };
  const totalYearsList = () => {
    return totalYears().map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  };
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">MANAGEMENT REPORT DOWNLOAD</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <ul className="text-left">
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Parent Facility
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <>
                  {facilityList ? (
                    <>
                      <Multiselect
                        name="parent_facility"
                        options={facilityList}
                        ref={parentFacRef}
                        isObject={false}
                        onSelect={(e) => {
                          facSelect(true);
                        }}
                        onRemove={(e) => {
                          facSelect(false);
                        }}
                      />
                      {errors.parent_facility && (
                        <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                          {errors.parent_facility?.message}
                        </p>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Group Code
                </label>
                <>
                  {groupCodeList ? (
                    <Multiselect
                      name="group_code"
                      options={groupCodeList}
                      ref={groupRef}
                      isObject={false}
                      onSelect={(e) => {
                        grpSelect(true);
                      }}
                      onRemove={(e) => {
                        grpSelect(false);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </>
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Select Charge Code
                </label>
                <>
                  {chargeCodeList ? (
                    <Multiselect
                      name="chargeCode"
                      displayValue="name"
                      options={chargeCodeList}
                      ref={chargeRef}
                      isObject={false}
                      onSelect={(e) => {
                        chargeSelect(true);
                      }}
                      onRemove={(e) => {
                        chargeSelect(false);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </>
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Report Month
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="report_month"
                  aria-label="Select Report Month"
                  ref={register({
                    required: "You must select Report Month",
                  })}
                  onChange={(e) => {
                    changeYearMnth();
                  }}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                >
                  <option value="">Select Report Month</option>
                  {totalMonths
                    ? totalMonths.map((monthName, i) => {
                        return (
                          <option key={i} value={("0" + (i + 1)).slice(-2)}>
                            {monthName}
                          </option>
                        );
                      })
                    : null}
                </select>
                {errors.report_month && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                    {errors.report_month?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Report Year
                </label>
                <select
                  name="report_year"
                  aria-label="Select Report Month"
                  defaultValue="2021"
                  onChange={(e) => {
                    changeYearMnth();
                  }}
                  ref={register({
                    required: false,
                  })}
                  className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                >
                  {totalYearsList()}
                </select>
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Facility Display name
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <input
                  id="facility_display_name"
                  name="facility_display_name"
                  type="text"
                  ref={register({
                    required: "You must specify Facility Display Name",
                  })}
                  className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                />
                {errors.facility_display_name && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                    {errors.facility_display_name?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Inmate Count
                </label>
                <input
                  id="inmate_count"
                  name="inmate_count"
                  type="number"
                  placeholder="Inmate Count"
                  ref={register({
                    required: "You must specify Inmate Count",
                    min: {
                      value: 1,
                      message: "Value must be greater than ZERO",
                    },
                  })}
                  defaultValue={1}
                  className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                />
                {errors.inmate_count && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                    {errors.inmate_count?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Med Surge
                </label>
                <input
                  id="med_surge"
                  name="med_surge"
                  type="number"
                  step=".01"
                  placeholder="Med Surge"
                  ref={register({
                    required: "You must specify Med Surge",
                  })}
                  defaultValue={1}
                  className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                />
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Destroyed Amount
                </label>
                <input
                  id="destroyedAmount"
                  name="destroyedAmount"
                  type="number"
                  placeholder="Destroyed Amount"
                  value={destroyedAmount}
                  onChange={(e) => setDestroyedAmount(e.target.value)}
                  className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                />
              </li>

              <li className="inline-block text-sm leading-8 w-1/3">
                <p>
                  <span className="rounded-md">
                    <input
                      name="psych_tab"
                      type="checkbox"
                      value={true}
                      ref={register({
                        required: false,
                      })}
                      disabled={psychTab}
                      className="mx-2"
                    />
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Has Psych Tab
                    </label>
                  </span>
                </p>
              </li>
              <li className="inline-block text-sm leading-8 w-1/3 mt-4">
                <p>
                  <span className="rounded-md">
                    <input
                      name="generate_excel"
                      type="checkbox"
                      value={true}
                      defaultChecked={true}
                      ref={register({
                        required: false,
                      })}
                      className="mx-2"
                    />
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Generate PDF
                    </label>
                  </span>
                </p>
              </li>

              <li className="inline-block text-sm leading-8 w-full">
                <button
                  type="submit"
                  className="text-white rounded  font-medium h-10 text-white w-full bg-secondary bg-login_btn mb-3 mt-3 focus:outline-none"
                  aria-label="Create user"
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({ }, dispatch);
    }
  )(ManagementReportDownld)
);